import React, { FC } from 'react';

import { Label, CaptionText } from './styled';

export const CaptionWrapper: FC<CaptionWrapperProps> = ({
  label,
  error,
  caption,
  children,
  wrapperStyle,
}) => (
  <div style={wrapperStyle}>
    {label && <Label>{label}</Label>}
    {children}
    {(caption || error) && <CaptionText $hasError={Boolean(error)}>{error || caption}</CaptionText>}
  </div>
);

export interface CaptionWrapperProps {
  label?: string;
  error?: string;
  /**
   * Пропадает при наличии "error"
   */
  caption?: string;
  wrapperStyle?: React.CSSProperties;
}
